import { useState } from "react";

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import i18next, { languages, changeAppLanguage } from "@plannel/utils/i18n";

const SelectLanguage = () => {
  const [lang, setLang] = useState(i18next.language);

  const languageItems = [
    { code: languages.EN_US, name: "English" },
    { code: languages.KO_KR, name: "한국어" },
    { code: languages.JA_JP, name: "日本語" },
    { code: languages.ZH_TW, name: "中文(繁體)" },
    { code: languages.ZH_CN, name: "中文(简体)" },
    { code: languages.VI_VN, name: "Tiếng Việt" },
  ];

  const changeLanguage = e => {
    const key = e.target.value;

    changeAppLanguage(key);
    setLang(key);
  }

  return (
    <FormControl className="language-select" sx={{ my: 1, minWidth: 120 }} size="small">
      <Select value={lang} onChange={changeLanguage}>
        {languageItems.map(language => {
          return <MenuItem value={language.code} key={language.code} sx={{ fontSize: "small" }}>{language.name}</MenuItem>
        })}
      </Select>
    </FormControl>
  )
}

export default SelectLanguage;